import { useSelector } from 'react-redux'
import PublicUnAuthAddress from '../PublicUnAuthAddress'
import FAQSection from './faqList'
import SelectQueryType from './selectQueryType'
import Consent from './consent'
import RaiseForm from './raiseForm'
import { useEffect, useRef, useState } from 'react'
import SuccessScreen from './successScreen'
import BookingList from './bookingList'
import CMSWidgetModal from '../../CMSWidget/cmsWidgetModal'
import CMSfaq from '../../CMSWidget/CMSfaq/cmsFAQ'
import OrSeparator from '../../../CMSComponent/Common/OrComponent'

const RaiseTicket = ({ data, widget_uuid }) => {
  const [formData, setFormData] = useState([{}])
  const [faqs, setFaqs] = useState([])
  const [bookingConsent, setbookingConsent] = useState({ show: false, status: false, visited: false })
  const [showLoginForm,setShowLoginForm] = useState(false)
  const [raiseTicketForm, setRaiseTicketForm] = useState({ show: false })
  const [showSuccessScreen, setShowSuccessScreen] = useState(false)
  const [createdTicketId,setCreatedTicketId] = useState(null)
  const userData = useSelector((state) => state.User.publicUser || state.User.user)
  const [selectedBooking, setSelectedBooking] = useState([])

  const [modalPosition, setModalPosition] = useState()

  const sectionRef = useRef(null)
  const sectionRef2 = useRef(null)
  const editMode = useSelector((state) => state.CMS.editMode)

  useEffect(() => {
    if (!formData?.[0]?.query_id) {
      setbookingConsent({ show: false, status: false, visited: false })
      setRaiseTicketForm({ show: false })
    } else if (formData?.[0]?.query_id && !faqs?.length) {
      setbookingConsent({ show: true, status: false, visited: false })
      setRaiseTicketForm({ show: false })
    }
  }, [formData?.[0]?.query_id, faqs.length])
  const handleSectionClick = () => {
    if (!editMode) return
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect()
      setModalPosition({
        top: 200,
        // left: 200, // Align left edge with parent element
        width: '100%',
      })
    }
  }
  const handleSectionClick2 = () => {
    if (!editMode) return
    if (sectionRef2.current) {
      const rect = sectionRef2.current.getBoundingClientRect()
      setModalPosition({
        top: 200,
        // left: 200, // Align left edge with parent element
        width: '100%',
      })
    }
  }
  const onCloseCMSModal = () => {
    let element = sectionRef?.current
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    }
    setModalPosition(null)
  }

  const heading = data?.find((item) => item?.component_name === 'heading')?.value
  const defaultFAQheading = data?.find((item) => item?.component_name === 'heading_two')?.value
  const FAQheadingWhenQuery = data?.find((item) => item?.component_name === 'heading_three')?.value
  const responseSolvingHeading = data?.find((item) => item?.component_name === 'heading_four')?.value
  const bookingConsentHeading = data?.find((item) => item?.component_name === 'heading_five')?.value
  const queryFormHeading = data?.find((item) => item?.component_name === 'heading_six')?.value
  const successHeading = data?.find((item) => item?.component_name === 'heading_seven')?.value
  const queryFormsubHeading = data?.find((item) => item?.component_name === 'sub_heading')?.value
  const additionalInfo = data?.find((item) => item?.component_name === 'additional_setting')?.value
  const additionalSetting = additionalInfo && JSON.parse(additionalInfo)

  if (showSuccessScreen) {
    return (
      <div className='mb-5' ref={sectionRef2} onClick={handleSectionClick2}>
        <SuccessScreen
          onGoBack={() => {
            setShowSuccessScreen(false)
            setSelectedBooking([])
            setFormData([{}])
            setCreatedTicketId(null)
          }}
          createdTicketId={createdTicketId}
          successHeading={successHeading?.replace(/<[^>]*>/g, '')}
        />
        {modalPosition && (
          <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseCMSModal()}>
            <CMSfaq data={data} widget_uuid={widget_uuid} toggleModal={() => onCloseCMSModal()} isRaiseTicket={true} showOnlyFields={['heading_seven']} hideManageQuestion={true}/>
          </CMSWidgetModal>
        )}
      </div>
    )
  }
  return (
    <div className='mb-5' ref={sectionRef} onClick={handleSectionClick}>
      <SelectQueryType data={data} formData={formData} setFormData={setFormData} heading={heading} />
      {formData?.[0]?.query_id ? (
        <div className='py-5'>
          <hr />
        </div>
      ) : (
        <div style={{ marginTop: '6rem', marginBottom: '6rem' }} className='px-5'>
          <OrSeparator />
        </div>
      )}

      <FAQSection
        formFieldValue={formData?.[0]}
        faqs={faqs}
        setFaqs={setFaqs}
        additionalSetting={additionalSetting}
        defaultFAQheading={defaultFAQheading}
        FAQheadingWhenQuery={FAQheadingWhenQuery}
      />
      {faqs?.length > 0 && (
        <div className='my-5'>
          <hr></hr>
        </div>
      )}

      {formData?.[0]?.query_id && faqs?.length > 0 && (
        <Consent
          title={responseSolvingHeading ? responseSolvingHeading?.replace(/<[^>]*>/g, '') : 'Is this response resolving your query?'}
          onYes={() => {
            setShowSuccessScreen(true)
          }}
          containedNoButton={bookingConsent?.show}
          onNo={() => {
            setbookingConsent({ show: true, status: false })
          }}
          disabled={bookingConsent?.visited}
        />
      )}
      {bookingConsent?.show && (
        <>
          <div className='my-5'>
            <hr></hr>
          </div>
          <Consent
            title={
              bookingConsentHeading ? bookingConsentHeading?.replace(/<[^>]*>/g, '') : 'Is this booking related to an attempted or completed booking?'
            }
            containedNoButton={!bookingConsent?.status && bookingConsent?.visited}
            containedYesButton={bookingConsent?.status}
            onYes={() => {
              setbookingConsent({ ...bookingConsent, visited: true, status: true })
              setRaiseTicketForm({ show: true })
            }}
            onNo={() => {
              setbookingConsent({ ...bookingConsent, visited: true, status: false })
              setRaiseTicketForm({ show: true })
            }}
          />
        </>
      )}

      {bookingConsent?.status && userData?.id && (
        <>
          <div className='my-5'>
            <hr></hr>
          </div>
          <BookingList setSelectedBooking={setSelectedBooking} selectedBooking={selectedBooking} />
        </>
      )}
      {!userData?.email && bookingConsent?.show && <PublicUnAuthAddress hideGuestCheckout />}

      {raiseTicketForm?.show && userData?.id && (
        <>
          {' '}
          <div className='my-5'>
            <hr></hr>
          </div>
          <RaiseForm
            formFieldValue={formData?.[0]}
            onSuccess={() => {
              setShowSuccessScreen(true)
            }}
            selectedBooking={selectedBooking}
            bookingConsentSelected={bookingConsent?.status}
            queryFormHeading={queryFormHeading}
            queryFormsubHeading={queryFormsubHeading}
            setCreatedTicketId={setCreatedTicketId}
          />
        </>
      )}
      {modalPosition && (
        <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseCMSModal()}>
          <CMSfaq data={data} widget_uuid={widget_uuid} toggleModal={() => onCloseCMSModal()} isRaiseTicket={true} />
        </CMSWidgetModal>
      )}
    </div>
  )
}

export default RaiseTicket
